import React from 'react';
import './CallToAction.css';
import imgCTA from '../../assets/images/vetores/Programming-amico.png';

// Reveal por scroll vem do observer único da aplicação (useReveal em App.tsx).

const CallToAction: React.FC = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(
      'Olá! Vim do site e gostaria de conversar sobre como vocês podem ajudar meu negócio.'
    );
    window.open(`https://wa.me/5521936185311?text=${message}`, '_blank');
  };

  const handleServicesClick = () => {
    const servicesSection = document.querySelector('.services-section, #services');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="cta-section">
      {/* Background Pattern */}
      <div className="cta-background-pattern"></div>

      <div className="cta-container">
        <div className="cta-content">
          {/* Texto */}
          <div className="cta-text reveal reveal--left">
            <h2 className="cta-title-cta">
              Pronto para transformar{' '}
              <span className="cta-highlight">seu negócio</span>?
            </h2>
            
            <p className="cta-description-cta">
              Não perca mais tempo com soluções que não funcionam. 
              Converse com nossos especialistas e descubra como 
              tecnologia de qualidade pode impulsionar seus resultados.
            </p>
            
            {/* Botões */}
            <div className="cta-buttons">
              <button 
                className="cta-button cta-button-primary"
                onClick={handleWhatsAppClick}
                aria-label="Entrar em contato via WhatsApp"
              >
                <svg className="button-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
                <span>Falar com Especialista</span>
              </button>
              
              <button 
                className="cta-button cta-button-secondary"
                onClick={handleServicesClick}
                aria-label="Conhecer nossos serviços"
              >
                <span>Ver Nossos Serviços</span>
                <svg className="button-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </button>
            </div>

            {/* Prova social */}
            <div className="cta-social-proof">
              <div className="proof-item">
                <svg className="proof-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>Resposta em até 1h</span>
              </div>
              
              <div className="proof-item">
                <svg className="proof-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>Consultoria gratuita</span>
              </div>
              
              <div className="proof-item">
                <svg className="proof-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
                <span>Sem compromisso</span>
              </div>
            </div>
          </div>
          
          {/* Imagem */}
          <div className="cta-image reveal reveal--right" style={{ '--i': 1 } as React.CSSProperties}>
            <div className="image-wrapper">
              <img 
                src={imgCTA} 
                alt="Especialista em tecnologia pronto para ajudar" 
                className="cta-img"
                loading="lazy"
              />
              <div className="image-glow"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;